import { dao } from '@platform/dao';
import type { IAiAskRequest, IAiAskResult } from '@platform/dao';
import { baseApi, run } from './baseApi';

/** ШІ-асистент: питання з контекстом сторінки й розмовою (POST /ai/ask); нічого не кешує й не змінює даних. */
export const aiApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    askAi: b.mutation<IAiAskResult, IAiAskRequest>({ queryFn: (body) => run(() => dao.ai.ask(body)) }),
  }),
});

export const { useAskAiMutation } = aiApi;
